import { render, staticRenderFns } from "./QuestionChangeQuestionable.vue?vue&type=template&id=728ece6d"
import script from "./QuestionChangeQuestionable.vue?vue&type=script&lang=ts"
export * from "./QuestionChangeQuestionable.vue?vue&type=script&lang=ts"
import style0 from "./QuestionChangeQuestionable.vue?vue&type=style&index=0&id=728ece6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports